import { Injectable } from '@angular/core';

@Injectable()

export class SelectedOrganization {

    public static OrganizationId: any;
    public static OrganizationName: string;
    public static mdmId: string;

    public static GetOrganizationDetails() {
        const OrganizationInfo = {
            Id: SelectedOrganization.OrganizationId,
            OrganizationName: SelectedOrganization.OrganizationName,
            mdmId: SelectedOrganization.mdmId
        };
        return OrganizationInfo;
    }
}

export class LoggedUser {
    static User: any;
}

export class OrganizationConstants {




    /* Form related componenets */
    public static FORM_NAME: string = "form_main";
    public static SAVE_BUTTON: string = "save_button";

    /* Radio items */
    public static RADIO_GROUP_ORGANIZATION: string = "organization_radio_group";

    public static CHOOSE_ORG: string = "Select the organization for which you want to request accommodations or EL supports authorized by ACT";
    public static INCOMPLETE_ORG_SETUP: string = "Account setup incomplete. Please associate yourself to an Organization and request a role to continue setup...";
    public static INCOMPLETE_ROLE_SETUP: string = "Account setup incomplete. Please request the appropriate Test Accommodations role for your organization...";

    public static TERMS_CHECKBOX: string = "termsCheckbox";
    public static TERMS_CHECKBOX_ERROR: string = "termsCheckboxError";

    public static EMPLOYEE_TEXT: string = "Are you an employee of an educational institution who needs to enter requests for test accommodations on behalf of examinees taking the ACT?";
    public static EMPLOYEE_NO_TEXT: string = "Test Coordinator access to the Test Accessibility and Accommodations System (TAA) is only available to employees of educational institutions. Please contact your school to submit a request for accommodations or call ACT at 319-337-1332.";
    public static AGREE_TEXT: string = "Do you agree to take responsibility for granting, revoking, and managing your educational institution's TAA roles/accesses?";
    public static AGREEE_NO_TEXT: string = "Test Coordinator access to the Test Accessibility and Accommodations System (TAA) is only available to employees of educational institutions who agree to manage all accesses for their organization. Please call ACT at 319-337-1322 with any questions.";
    public static PERMISSION_TEXT: string = "Do you have permission and authority from your educational institution to access and disclose student-level data and other sensitive personal information related to accommodations requests you submit through TAA on the examinee's behalf?";
    public static PERMISSION_NO_TEXT: string = "Test Coordinator access to the Test Accessibility and Accommodations System (TAA) is only available to employees of educational institutions who have permission to access student-level data. Please call ACT at 319-337-1322 with any questions.";

    public static SELECT_ROLE: string = "Select the appropriate role below to gain access to the Test Accessibility and Accommodations System.  Once approved, both test coordinators and test accommodations coordinators can request accommodations and/or supports on behalf of examinees at your school.";
    public static TC_DESC: string = "Each sschool must have one test coordinator. The test coordinator's access is approved by ACT. Once the test coordinator has access, he/she can grant access to test accommodations coordinators.";
    public static TAC_DESC: string = "Do NOT request this access unless your school has a test coordinator with access to the Test Accessibility and Accommodations System. If your school has a test coordinator, request that he/she approves your test accommodations coordinator access. ACT does not approve access requests for test accommodations coordinators.";

    public static THANK_YOU_TEXT_1: string = "Thank you for submitting the Test Coordinator Access Form. ";
    public static THANK_YOU_TEXT_2: string = "Please notify your administrator that ACT will be in contact to validate your access. You will receive an email notification when review of your access request is complete.";
    public static TAC_THANK_YOU_TEXT_1: string = "Thank you for submitting a request for test accommodations coordinator access to TAA. ";
    public static TAC_THANK_YOU_TEXT_2: string = "Contact the test coordinator at your school who will approve your request. ACT does not approve access requests for test accommodations coordinators.";

    public static TEST_COORDINATOR_EXISTS_ERROR_1: string = "Our records indicate that ";
    public static TEST_COORDINATOR_EXISTS_ERROR_2: string = "is the Test Coordinator for ";
    public static TEST_COORDINATOR_EXISTS_ERROR_3: string = ". ACT allows only one Test Coordinator per organization. You can select Cancel and then, select the Request TAA Access button and the Request Test Accommodations Coordinator Role button. The Test Accommodations Coordinator Role will be approved by the Test Coordinator at your organization. Or, you can continue to request the Test Coordinator Role. Please be advised that if your Test Coordinator Role is approved, ACT will revoke the access of ";
    public static TEST_COORDINATOR_EXISTS_ERROR_4: string = "If you need assistance, please contact ACT Customer Service Support at 877.789.2925.";

    public static NO_ORG_ID_EXISTS_ERROR: string = "is not in the TAA system yet. If the organization should be in TAA system please check back in 1 hour as we may not have processed the request yet. If the organization is not here when you check back, please contact ACT Customer Service Support at 877.789.2925.";
    public static MULTI_ORG_ID_EXISTS_ERROR: string = "Multiple organizations are attached in the TAA system. In order to continue, please contact ACT Customer Service Support at 877.789.2925.";
    public static ORG_HAS_NO_ACCESS_IN_TAA_ERROR: string = "This organization has not been added to the TAA system. In order to continue, please contact ACT Customer Service Support at 877.789.2925.";


}







// WEBPACK FOOTER //
// ./client/views/constants/organization-constants.ts